<template>
  <v-menu offset-y left :disabled="disabled">
    <template v-slot:activator="{ on, attrs }">
      <button v-tip="'Später erinnern'" :class="small ? 'ntp-snooze' : 'ntf-act'" :disabled="disabled" aria-label="Später erinnern"
              type="button" v-bind="attrs" v-on="on">
        <v-icon :x-small="small" :small="!small">mdi-bell-sleep-outline</v-icon>
        <template v-if="small">Später</template>
      </button>
    </template>
    <v-list class="soft-menu py-1" dense>
      <v-subheader class="ntp-snooze__head">Später erinnern</v-subheader>
      <v-list-item v-for="option in options" :key="option.value" @click="$emit('snooze', option.value)">
        <v-list-item-title>{{ option.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import Vue from 'vue';
import {NOTIFICATION_SNOOZE_OPTIONS} from '@/components/app/appBar/notifications/notificationActions.helper';

/** "Später erinnern" for a notification (new notifier only): 1 Std., 3 Std., morgen 8 Uhr, nächste Woche */
export default Vue.extend({
  name: 'NotificationSnoozeMenu',
  props: {
    disabled: {type: Boolean, default: false},
    /** Text button of the pop-up; otherwise icon button of the panel row */
    small: {type: Boolean, default: false},
  },
  computed: {
    options: () => NOTIFICATION_SNOOZE_OPTIONS,
  },
});
</script>

<style scoped>
.ntp-snooze__head {
  height: 28px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: .04em;
}

.ntp-snooze .v-icon, .ntf-act .v-icon {
  color: inherit !important;
}
</style>
